export default "__VITE_ASSET__CAbpxa3$__";